import { MemberInfoViewModel } from '@apis/model';
import { ChangePasswordResponse } from '@ul/api';

export const toMemberInfoViewModel = (response: ChangePasswordResponse): MemberInfoViewModel | undefined => {
    const { memberInfo } = response;
    if (!memberInfo) {
        return;
    }

    return {
        email: memberInfo.email,
        phone: memberInfo.phone,
        countryCode: memberInfo.countryCode,
    };
};
